import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import HeroSection from "./components/HeroSection";
import QuoteForm from "./components/QuoteForm";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import WhyChooseUs from "./components/WhyChooseUs";
import TestimonialsSection from "./components/TestimonialsSection";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <QuoteForm />
        <AboutSection />
        <ServicesSection />
        <WhyChooseUs />
        <TestimonialsSection />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}